import { Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import BatteryIcon from './BatteryIcon'

interface MinCardProps {
  name?: string
  value?: string
  unit?: string
  statusText?: string
  batterySOC?: number
}

const MinCard: React.FC<MinCardProps> = ({ name = '', value = '', unit = '', statusText = '', batterySOC }) => {
  const { t } = useTranslation()
  const statusColor = {
    success: '#7DC058',
    info: '#B8B8B8',
    error: '#BA2525',
    warning: '#F8B552',
  }
  const [status, setStatus] = useState<'info' | 'success' | 'error' | 'warning'>('info')
  useEffect(() => {
    if (
      statusText === 'exporting' ||
      statusText === 'discharging' ||
      statusText === 'running' ||
      statusText === 'buying'
    ) {
      setStatus('success')
    } else if (
      statusText === 'importing' ||
      statusText === 'charging' ||
      statusText === 'selling' ||
      statusText === 'loaded'
    ) {
      setStatus('warning')
    } else {
      setStatus('info')
    }
  }, [statusText])

  return (
    <div className='flow-min-card'>
      <img className='rights' src='/assets/image/right.svg'></img>
      <div className='flow-min-card-icon'>
        {/* <Flex align="center" gap={10}>
            {!name.includes("Battery") && (
              <img src={"/assets/image/" + name.replace(/\s+/g, "").toLowerCase() + ".svg"} />
            )}
  
            {name.includes("Battery") && <BatteryIcon />}
            {append && <Tag color="success">{append}</Tag>}
          </Flex> */}

        {name !== 'battery' && <img src={'/assets/image/' + name.replace(/\s+/g, '') + '.svg'} />}
        {name === 'battery' && <BatteryIcon jd={batterySOC ? batterySOC : 0} />}
      </div>
      <div className='flow-min-card-value'>
        {/* <NumberScroller targetNumber={value} /> */}
        {value}&nbsp;
        <span>{unit}</span>
      </div>
      <div className='flow-min-card-name'>
        <Flex align='center' gap={5}>
          {t('site.' + name)}
          {batterySOC ? `(${batterySOC}%)` : ''}
          {/* <Popover content=<Popcontent /> placement="bottom">
              <img src="/assets/image/more.svg" className="mores" style={{ marginTop: 3 }} />
            </Popover> */}
        </Flex>
      </div>
      <div className='flow-min-card-bottom'>
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <circle cx='8' cy='8' r='8' fill={statusColor[status]} />
          <path d='M4.5 9.88889L8 6L11.5 9.88889' stroke='white' />
        </svg>
        {t(`site.${statusText}`)}
      </div>
    </div>
  )
}

export default MinCard
